import { ComputedRef, InjectionKey, Ref } from 'vue';
import { SpecifiedMethod } from '@/types';

export const adpDocumentCardWrapperRefKey = Symbol(
  'adpDocumentCardWrapperRef',
) as InjectionKey<Ref<HTMLElement | null>>;

export const visibleAdpCardKey = Symbol(
  'adpDocumentCardWrapperRef',
) as InjectionKey<Ref<boolean>>;

export const closeAllDocumentsKey = Symbol(
  'closeAllDocumentsKey',
) as InjectionKey<Ref<boolean>>;

export const specifiedMethodKey = Symbol('specifiedMethodRef') as InjectionKey<
  Ref<SpecifiedMethod | undefined>
>;

export const surveyHistorySourcesKey = Symbol(
  'surveyHistorySourceUrls',
) as InjectionKey<ComputedRef<Array<string>>>;
